import ApiResponseDisplayer from '@components/ApiResponseDisplayer';
import AppContext from '@services/Context';
import { Button, Card, Col, Divider, Icon, Modal, Row, Spin } from 'antd';
import React from 'react';

import I18n from '../i18n';
import styled from '../styled-components';


type PropType = {
  title: string;
  data: any[];
  showModal: boolean;
  auditorAuditsIds: any[];
  onItemSelected: Function;
  onItemRemoved: Function;
  onToggleFormModal: Function,
  loadingData: boolean,
  serverResponse: any;
  customSavedDataTitle?: string;
  customNoSavedItemsString?: string;
  customNoItemsToSaveString?: string;
  customWhereCreateItemsInfoString?: string;
  customNoInfoString?: string;
  savedDefaultValues?: string[];
  hasMoreProcessesToSave?: boolean,
  onSeeMorePressed?: Function,
  loadingSeeMore?: boolean,
};
type StateType = {
  auditsData: any[];
  alreadySavedData: any[];
  dataFormatted: boolean;
};

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class SelectableDataComponent extends React.Component<PropType, StateType> {

  state = {
    auditsData: [],
    alreadySavedData: [],
    dataFormatted: false,
  };

  constructor(props: any) {
    super(props);
  }

  renderAvailableAudits() {
    return (
      <AppContext.Consumer>
        {() => (
          this.state.auditsData.map((item: any, i: number) => {
            return (
              <Card key={i}
                className={(item.loading) ? "user-card disabled-card" : "user-card goepik-card-hover"}
                onClick={() => (item.loading ? null : this.userCardClicked(item.id))} >

                <div className='item-name'> {item.name} </div>
                <div className='item-loading'>
                  {item.loading && (
                    <Spin indicator={antIcon} />
                  )}
                </div>

              </Card>
            )
          })
        )}
      </AppContext.Consumer>
    )
  }

  renderSavedDefaultValues() {
    if (this.props.savedDefaultValues == undefined || this.props.savedDefaultValues.length == 0)
      return;

    return (
      <React.Fragment>
        {this.props.savedDefaultValues.map((item: string, i: number) => {
          return (
            <div key={i} className={"user-saved-row"}>
              <span>{item}</span>
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  renderSavedProcesses() {
    return (
      <AppContext.Consumer>
        {({ locale, theme }) => (
          this.state.alreadySavedData.map((item: any, i: number) => {
            return (
              <div key={i} className={"user-saved-row"}>
                <div className='item.name'>{item.name}</div>
                <div className='item.loading'>
                  {item.loading && (
                    <Spin indicator={antIcon} />
                  )}
                  {!item.loading && (
                    <Icon
                      style={{ color: 'red' }}
                      className="dynamic-delete-button goepik-delete-icon"
                      type="close"
                      onClick={() => this.props.onItemRemoved(item.id)}
                    />
                  )}
                </div>
              </div>
            )
          })

        )}
      </AppContext.Consumer>
    )
  }

  formatNonSavedAudits = async (data: any[], auditorAuditsIds: string[]) => {
    if (auditorAuditsIds != undefined && data != undefined) {
      const newAuditsData = data.filter((item: any) => {
        return auditorAuditsIds.indexOf(item.id) == -1;
      })
      const newSavedData = data.filter((item: any) => {
        return auditorAuditsIds.indexOf(item.id) != -1;
      })
      this.setState({
        auditsData: newAuditsData,
        alreadySavedData: newSavedData,
      });
    }

  }

  shouldComponentUpdate(nextProps: any) {

    if (nextProps.data != this.props.data && this.props.data != undefined) {
      this.formatNonSavedAudits(nextProps.data, nextProps.auditorAuditsIds);
      return false;
    }
    if (nextProps.auditorAuditsIds != this.props.auditorAuditsIds) {
      this.formatNonSavedAudits(nextProps.data, nextProps.auditorAuditsIds);
    }
    return true;
  }


  userCardClicked(id: string) {
    this.props.onItemSelected(id)
  }

  renderData() {
    const {
      data,
      customNoInfoString,
      customWhereCreateItemsInfoString,
      customNoItemsToSaveString,
      customSavedDataTitle,
      savedDefaultValues,
      customNoSavedItemsString
    } = this.props;

    const {
      auditsData,
      alreadySavedData,
    } = this.state;

    if ((!this.props.data || this.props.data.length === 0) && (!this.props.savedDefaultValues || this.props.savedDefaultValues.length == 0)) {
      return (
        <Col md={22}>
          <p>{customNoInfoString ? customNoInfoString : I18n.l('process.titles.noProcessesRegistered')}</p>
          <p>{customWhereCreateItemsInfoString ? customWhereCreateItemsInfoString : I18n.l('process.titles.whereAddProcessInfo')}</p>
        </Col>
      )
    }

    return (
      <React.Fragment>

        <Col md={10}>
          {(auditsData.length > 0 || alreadySavedData.length > 0) && (
            <div>
              <TableWrapper>
                {this.renderAvailableAudits()}
              </TableWrapper>
            </div>
          )}
          {(auditsData == undefined || auditsData.length == 0) && (
            <p>{customNoItemsToSaveString ? customNoItemsToSaveString : I18n.l('process.titles.noProcessesToSave')}</p>
          )}
        </Col>

        <Col md={2} className="goepik-medium-left-margin">
          <Divider type="vertical" />
        </Col>


        <Col md={10} className="goepik-medium-left-margin">
          <Row className={"processes-saved-title"}>
            <p>{customSavedDataTitle ? customSavedDataTitle : I18n.l('common.bound')}</p>
          </Row>
          <SavedDataWrapper >
            <Row >
              {(savedDefaultValues != undefined && savedDefaultValues.length) > 0 && (
                this.renderSavedDefaultValues()
              )}

              {alreadySavedData.length > 0 && (
                this.renderSavedProcesses()
              )}
              {(alreadySavedData == undefined || alreadySavedData.length == 0) && (savedDefaultValues == undefined || savedDefaultValues.length == 0) && (
                <p>{customNoSavedItemsString ? customNoSavedItemsString : I18n.l('process.titles.noProcessesSaved')}</p>
              )}

            </Row>
          </SavedDataWrapper>
        </Col>



      </React.Fragment>
    );
  }

  render() {
    const {
      title,
      loadingData,
      serverResponse,
      onToggleFormModal,
      showModal,
      hasMoreProcessesToSave,
      onSeeMorePressed,
      loadingSeeMore,
    } = this.props;

    const {
    } = this.state;


    return (
      <AppContext.Consumer>
        {({ theme, locale }) => (
          <Wrapper>
            <LargeModal>
              <Modal visible={showModal} wrapClassName={"large-modal"} footer={false} closable={false} >
                <ModalTitle>{title}</ModalTitle>
                <ModalContent>
                  <Row className={"content-holder"}>
                    {loadingData && (
                      <p>{I18n.l('common.loadingTable')}</p>
                    )}
                    {loadingData == false && (
                      this.renderData()
                    )}
                  </Row>

                  {serverResponse && (
                    <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                  )}
                  <Row style={{ marginTop: '10px' }}>
                    <Col md={10}>
                      {hasMoreProcessesToSave && (
                        <Button
                          type="primary"
                          ghost
                          onClick={() => onSeeMorePressed != undefined ? onSeeMorePressed() : {}}
                          loading={loadingSeeMore}
                        >
                          {I18n.l('common.seeMore')}
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <div className="goepik-component-padding">
                    <Row type="flex" justify="end">
                      <Button className="main-button" type="primary" ghost size="large" onClick={() => onToggleFormModal()}>
                        {I18n.l('common.close')}
                      </Button>
                    </Row>
                  </div>
                </ModalContent>
              </Modal>
            </LargeModal>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const LargeModal = styled.div`
    .large-modal{
        width: 45%;
        height: 300px;
    }
`;

const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
`;

const ModalContent = styled.div`
    .content-holder{
        height: 300px;
    }
    .processes-saved-title{
        font-weight: bold;
    }
    .goepik-delete-icon:hover{
        cursor:pointer;
    }

    .goepik-component-padding{
        color:#a3a3a3;
        font-weight:bold;
        font-size:14px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .searchBtn{
        border-color: #1890ff;
        color: #1890ff;
    }
    .margied-elements{
        margin-left:10px;
    }
    .ant-divider, .ant-divider-vertical{
        height: 255px;
        margin-top: 8px;
    }
`;

const TableWrapper = styled.div`
    overflow-y:auto;
    max-height: 280px;
    margin-top: 28px;

    .selectable-row{
        cursor: pointer;
    }
    .locked-row{
        cursor: not-allowed;
    }

    .ant-card-body{
        padding: 8px;
        display:flex;
        justify-content: space-between;
        width: 100%;
        align-items:center;

        > div:first-of-type{
            padding-right: 8px;
        }
    }

    .goepik-card-hover:hover{
        cursor:pointer;
    }
    .user-card{
        width: 100%;
        padding: 2px;
        margin-top:2px;
        display:flex;
        
        .item-name{
            flex: 6;     
            max-width: 165px;       
        }
        .item-loading{
            flex: 1;
        }
    }
    .disabled-card{
        background-color:#f3f3f3;        
    }
`

const SavedDataWrapper = styled.div`
  max-height: 278px;
  overflow-y: auto;
  overflow-x: hidden;

  .user-saved-row{
    display:flex;
    
    align-items:center;
    margin-bottom: 10px;
    width: 100%;
    justify-content: space-between;

    > div:first-of-type :not(:last-child) {
      padding-right: 8px;
      max-width: 175px;
    }

    > div:not(:last-child) {
      padding-bottom: 8px;
    }

    .item-name{
      flex: 6;
    }
    .item-loading{
        flex: 1;
    }
  }
`

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow-x: auto;
    width: 100%;

    .ant-table-wrapper {
            width: 99.9%;

            button {
                border: 0;
            }
    }

    .action-buttons {
        display: block;
        text-align: right;
        button {
        margin: 0 0 3px 0px;
        padding: 3px;
        width: 70px; 
        }
    
    }

    table {
        td {
            .disabled {
                color: #ccc;
            }
        }
    }
`;

export default SelectableDataComponent;
